// extracted by mini-css-extract-plugin
module.exports = {"shop_menu":"ShopMenu_shop_menu_17-PV","select":"ShopMenu_select_2Wr_5","shop_fig":"ShopMenu_shop_fig_2J2Z6"};